import { ErrorMessage } from './ErrorMessage';
export default ErrorMessage;
